export default __webpack_public_path__ + "static/media/maintenanceMobile.b30ee16c.png";